import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-beteen;
  padding: 0 20px 80px 20px;
  position: relative;
  min-width: 1140px;
`;

export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 80px;
  padding: 0 20px;
  align-items: center;
`;

export const Rectangle = styled.div`
  width: 100%;
  height: 160px;
  background-color: var(--global-color-blue-98);
`;

export const ProfileContainer = styled.div`
  gap: 40px;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 152px;
  align-items: center;
`;

export const ProfileImg = styled.img`
  width: 160px;
  height: 160px;
  background-color: var(--alias-color-background-normal-normal);
  box-shadow: var(--alias-style-shadow-strong);
  border-radius: 24px;
  box-sizing: border-box;
`;

export const IconContainer = styled.div`
  position: absolute;
  left: 136px;
  top: 136px;
  box-shadow: var(--alias-style-shadow-normal);
  border-radius: 8px;
`;

export const EditContainer = styled.div`
  box-sizing: border-box;
  padding: 160px 20px 80px 20px;
  margin: 0 auto;
  min-height: 448px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const BottonContainer = styled.div`
box-sizing: border-box;
  padding: 0px 20px;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: end;
`;

export const DeleteBtn = styled.div`
  padding: 2px 0px;
`;
